const { getOffset } = require('./navbar');

const scrollToTarget = $target => {
	const headerOffset = getOffset();
	const elementPosition = $target.getBoundingClientRect().top;
	const offsetPosition = elementPosition + window.scrollY - headerOffset;
	window.scrollTo({
		top: offsetPosition,
		behavior: 'smooth'
	});
};

const init = () => {
	document.querySelectorAll('.js-scrollto').forEach($el => {
		let $target;
		if ($el.hasAttribute('data-scrollto-target')) {
			$target = document.querySelector($el.getAttribute('data-scrollto-target'));
		} else {
			// Either get the next sibling that is a section, else just the next
			// if no more siblings exist, stop.
			const $section = $el.closest('section');
			let $cur = $section;
			let stop = false;
			do {
				if ($cur.nextElementSibling) {
					if ($cur.nextElementSibling.nodeName === 'SECTION') {
						$target = $cur.nextElementSibling;
						stop = true;
					} else {
						$cur = $cur.nextElementSibling;
					}
				} else {
					stop = true;
				}
			} while (!stop);
		}

		if (!$target) return;

		$el.addEventListener('click', e => {
			e.preventDefault();
			scrollToTarget($target);
		});
	});
};

module.exports = {
	init
};
